import React from "react";
import { CreateCard } from "./CreateCard";
import { STRATEGIES } from "./mockData";
import { StrategyCard } from "./StrategyCard";

export function StrategiesSection() {
  return (
    <div className="mt-12">
      <div className="flex justify-between items-end mb-6">
        <h2 className="text-2xl font-bold text-gray-200">My strategies</h2>
        <button
          type="button"
          className="text-gray-400 text-sm hover:text-white flex items-center gap-1"
        >
          View all <span className="text-xs">▶</span>
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 pb-20">
        <CreateCard />
        {STRATEGIES.map((strategy) => (
          <StrategyCard key={strategy.id} data={strategy} />
        ))}
      </div>
    </div>
  );
}
